import adapterDataPagination from 'projects/access-control/src/app/Domain/Adapters/pagination.adapter';
import { Groups } from 'projects/access-control/src/app/Domain/Entities/group.interface';
import { GroupsUsers, UsersGroups } from 'projects/access-control/src/app/Domain/Entities/userGroups.interface';
import { createReducer, on } from '@ngrx/store';
import {
	createStatusGroup,
	createStatusGroupError,
	createStatusGroupSuccess,
	deleteBulkUsersGroupsSuccess,
	deleteGroup,
	deleteGroupError,
	deleteGroupSuccess,
	deleteStatusGroup,
	deleteStatusGroupError,
	deleteStatusGroupSuccess,
	getAllGroup,
	getAllGroupError,
	getAllGroupSuccess,
	getDetailGroups,
	getDetailGroupsError,
	getDetailGroupsSuccess,
	getGroup,
	getGroupError,
	getGroupSuccess,
	getSubGroups,
	getSubGroupsError,
	getSubGroupsSuccess,
	getUsersGroups,
	getUsersGroupsError,
	getUsersGroupsSuccess,
	postGroup,
	postGroupError,
	postGroupSuccess,
	postUsersGroups,
	postUsersGroupsError,
	postUsersGroupsSuccess,
	searchUsersGroups,
	searchUsersGroupsError,
	searchUsersGroupsSuccess,
	updateGroup,
	updateGroupError,
	updateGroupSuccess,
	updateSelectedGroup,
	updateSelectedGroupError,
	updateSelectedGroupSuccess,
	updateStatusGroup,
	updateStatusGroupError,
	updateStatusGroupSuccess,
	updateUsersGroups,
	updateUsersGroupsError,
	updateUsersGroupsSuccess,
} from './groups.action';
import { initialStateModule } from './groups.state';

export const reducerGroup = createReducer(
	initialStateModule,
	on(getGroupSuccess, (state, { group }) => ({
		...state,
		groups: group,
		groupSelected: {} as Groups,
		loading: false,
		loadingGeneral: false,
		error: null,
		viewGroups: true,
	})),
	on(getAllGroupSuccess, (state, { groups }) => ({
		...state,
		groups,
		groupSelected: {} as Groups,
		loading: false,
		loadingGeneral: false,
		error: null,
	})),
	on(updateGroupSuccess, (state, { group }) => {
		const groups = [...state.groups] as Groups[];
		return {
			...state,
			loading: false,
			loadingGeneral: false,
			groups: groups.map((elementGroup) => {
				return elementGroup.pk === group.pk && elementGroup.sk === group.sk
					? { ...group, subGroups: elementGroup.subGroups, users: elementGroup.users }
					: { ...elementGroup, subGroups: elementGroup.subGroups, users: elementGroup.users };
			}) as Groups[],
			error: null,
		};
	}),

	on(
		updateSelectedGroupSuccess,
		createStatusGroupSuccess,
		updateStatusGroupSuccess,
		deleteStatusGroupSuccess,
		(state, { group }) => ({
			...state,
			loading: false,
			loadingGeneral: false,
			groupSelected: { ...group, detailGroups: group },
			error: null,
		})
	),
	on(deleteGroupSuccess, (state, { ids }) => {
		const item = [...state.groups] as Groups[];
		let groups: Groups[] = [];
		item.forEach((groupSelected: Groups) => {
			if (groupSelected.sk != ids.sk) {
				groups.push(groupSelected);
			}
		});
		return {
			...state,
			groups,
			loading: false,
			loadingGeneral: false,
			groupSelected: state.groupSelected?.sk === ids.sk ? ({} as Groups) : state.groupSelected,
			error: null,
		};
	}),
	on(getSubGroupsSuccess, (state, { group }) => ({
		...state,
		groups: group,
		loading: false,
		loadingGeneral: false,
		viewGroups: false,
		error: null,
	})),
	on(getUsersGroupsSuccess, searchUsersGroupsSuccess, (state, { user, pagination }) => ({
		...state,
		loading: false,
		loadingGeneral: false,
		groupSelected: {
			...state.groupSelected,
			dataUsers: {
				users: user,
				paginationIni: pagination,
				pagination: adapterDataPagination(pagination),
			},
		},
		error: null,
	})),
	on(getDetailGroupsSuccess, (state, { detailGroups }) => {
		const groupsData = [...state.groups] as Groups[];
		const groups: Groups =
			groupsData.find((data) => data.sk === detailGroups.sk && data.pk === detailGroups.pk) ||
			({} as Groups);
		let groupSelected = {
			...detailGroups,
		} as Groups;
		if (groups.sk) {
			groupSelected = {
				...groupSelected,
				...groups,
			};
		}
		return {
			...state,
			loadingGeneral: false,
			groupSelected,
			error: null,
		};
	}),
	on(postGroupSuccess, (state, { group }) => {
		let groups: Groups[] = [];
		let groupsState = [...state.groups] as Groups[];
		if (state.groupSelected?.sk) {
			if (state.groupSelected.subGroups > 0) {
				groups = [group, ...groupsState];
			} else {
				groups = [group];
			}
		} else {
			groups = [group, ...groupsState];
		}

		return {
			...state,
			groups,
			groupSelected: {
				...state.groupSelected,
				subGroups: state.groupSelected.subGroups + 1,
			},
			loading: false,
			loadingGeneral: false,
			error: null,
		};
	}),
	on(postUsersGroupsSuccess, (state, { user }) => ({
		...state,
		loading: false,
		loadingGeneral: false,
		groupSelected: {
			...state.groupSelected,
			dataUsers: {
				users: [user, ...state.groupSelected.dataUsers.users],
				paginationIni: state.groupSelected.dataUsers.paginationIni,
				pagination: adapterDataPagination(
					state.groupSelected.dataUsers.paginationIni,
					state.groupSelected.dataUsers.users.length,
					+1,
					state.groupSelected.dataUsers.pagination.total,
					state.groupSelected.dataUsers.pagination.pageTo
				),
			},
		},
		error: null,
	})),
	on(updateUsersGroupsSuccess, (state, { user }) => {
		const users = state.groupSelected.dataUsers.users.map((userItem) => {
			if (userItem.pk === user.pk && user.sk === userItem.sk) {
				const groupsData = user.groupModify;
				return {
					...user,
					groups: [groupsData] as GroupsUsers[],
				};
			} else {
				return userItem;
			}
		});

		return {
			...state,
			loading: false,
			loadingGeneral: false,
			groupSelected: {
				...state.groupSelected,
				dataUsers: {
					...state.groupSelected.dataUsers,
					pagination: state.groupSelected.dataUsers.pagination,
					users,
				},
			},
			error: null,
		};
	}),
	on(deleteBulkUsersGroupsSuccess, (state, { user }) => {
		const users: UsersGroups[] = [...state.groupSelected.dataUsers.users];
		user.forEach((userElement) => {
			const userIndex = users.findIndex(
				(index) => index.sk === userElement.sk && index.pk === userElement.pk
			);
			users.splice(userIndex, 1);
		});
		return {
			...state,
			loading: false,
			loadingGeneral: false,
			groupSelected: {
				...state.groupSelected,
				dataUsers: {
					users,
					paginationIni: state.groupSelected.dataUsers.paginationIni,
					pagination: adapterDataPagination(
						state.groupSelected.dataUsers.paginationIni,
						state.groupSelected.dataUsers.users.length,
						-user.length,
						state.groupSelected.dataUsers.pagination.total,
						state.groupSelected.dataUsers.pagination.pageTo
					),
				},
			},
			error: null,
		};
	}),
	on(
		updateGroupError,
		postGroupError,
		getSubGroupsError,
		getDetailGroupsError,
		getGroupError,
		deleteGroupError,
		getUsersGroupsError,
		searchUsersGroupsError,
		postUsersGroupsError,
		getAllGroupError,
		updateUsersGroupsError,
		updateSelectedGroupError,
		deleteStatusGroupError,
		updateStatusGroupError,
		createStatusGroupError,
		(state, action) => ({
			...state,
			loading: false,
			loadingGeneral: false,
			error: action.error.error.errorMessage,
		})
	),
	on(updateGroup, postGroup, getSubGroups, deleteGroup, getAllGroup, (state, action) => ({
		...state,
		loading: true,
	})),
	on(getGroup, (state, action) => ({
		...state,
		loading: true,
		viewGroups: true,
		groups: [],
	})),
	on(
		getDetailGroups,
		getUsersGroups,
		searchUsersGroups,
		postUsersGroups,
		updateUsersGroups,
		updateSelectedGroup,
		deleteStatusGroup,
		updateStatusGroup,
		createStatusGroup,
		(state, action) => ({
			...state,
			loadingGeneral: true,
		})
	)
);
